import { PartialType } from '../../../../utils';
import { CreateVehicleModelAudioDto } from '../create/create-vehicle-model-audio.dto';
export class UpdateVehicleModelAudioDto extends PartialType(CreateVehicleModelAudioDto) {
}
